module.exports = __webpack_public_path__ + "img/settings-icon.9bfd16a7.svg";